export enum dashSlaTypes {
  'LOAD_RESUMO_ATENDIMENTO_REQUEST' = '@resumoAtendimento/LOAD_RESUMO_ATENDIMENTO_REQUEST',
  'RESUMO_ATENDIMENTO_SUCCESS' = '@resumoAtendimento/RESUMO_ATENDIMENTO_SUCCESS',
  'RESUMO_ATENDIMENTO_FAILURE' = '@resumoAtendimento/RESUMO_ATENDIMENTO_FAILURE',
}

export type TipoSolicitacao = {
  tipo: string;
  valor: number;
};

export type Clientes = {
  codParc: number;
  concluido: number;
  pendente: number;
  protocolosConcluido: string;
  protocolosPendente: string;
  razaoSocial: string;
  total: number;
};

export interface dashSla {
  percSla: number;
  tipoSolicitacao: TipoSolicitacao[];
  clientes: Clientes[];
}

export interface DashSlaState {
  readonly data: dashSla[];
  readonly loading: boolean;
  readonly error: boolean;
}
